module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex pt4 pointer",
    on: {
      "click": function($event) {
        _vm.showDetails = !_vm.showDetails
      }
    }
  }, [_c('h2', {
    staticClass: "f3 flex-grow"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    staticClass: "f3"
  }, [_vm._v(_vm._s(_vm.showDetails ? '-' : '+'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }]
  }, [_vm._t("default")], 2), _vm._v(" "), _c('hr', {
    staticClass: "mt3"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8c6ab24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaqSection.vue
// module id = 494
// module chunks = 0